module.exports = __webpack_public_path__ + "static/media/cancel.74bc0bef.svg";